const cookieExpDays = 1;
const cookieInAppName = "inAppsRecurrenceData";

/**
 * Verify and Handle the requirements to show an inApp
 * @param {string} inAppModal - element of the inApp
 * @returns {boolean} boolean if the in app is allowed to open
 */
function showInApp(inAppModal) {
    var devices = inAppModal.data("devices");
    const isMobileOrTablet = window.mqRespond.status.mobile || window.mqRespond.status.tablet;
    if (((devices == "mobile" || devices == "app") && !isMobileOrTablet) || (devices == "desktop" && isMobileOrTablet)) {
        return false;
    }

    var recurrenceData;
    var recurrenceLimit = inAppModal.data("recurrence");
    var recurrenceAuth = inAppModal.data("auth-recurrence");
    if (recurrenceAuth != null) {
        return recurrenceAuth <= recurrenceLimit && recurrenceAuth != -1;
    }

    var inAppCookie = getInAppsCookie();
    var inAppCookieValue;
            
    if (!inAppCookie) {
        recurrenceData = {};
    } else {
        inAppCookieValue = inAppCookie.split("|");
        recurrenceData = JSON.parse(inAppCookieValue[0]);
    }

    var inAppId = inAppModal.attr("id");
    if ((recurrenceData[inAppId] != null) && ((recurrenceLimit && recurrenceData[inAppId] >= recurrenceLimit) || recurrenceData[inAppId] == -1)) {
        return false;
    }
    
    recurrenceData[inAppId] = (recurrenceData[inAppId] || 0) + 1;

    if (!inAppCookie) {
        setInAppsCookie(JSON.stringify(recurrenceData));
    } else {
        updateInAppsCookie(JSON.stringify(recurrenceData), inAppCookieValue[1]);
    }

    return true;
}

/**
 * Verify and Handle the requirements to show an inApp
 * @param {string} inAppModal - DOM element of the inApp
 * @returns {boolean} boolean if the in app is allowed to open
 */
function handleDismissInApp(btn) {
    var inAppModal = btn.closest(".js-in-apps-modal");
    const recurrenceAuth = inAppModal.data("auth-recurrence");
    if (recurrenceAuth != null) {
        dismissAuthInApp(inAppModal);
    } else {
        dismissCookieInApp(inAppModal);
    }
}

/**
 * Send request to dismiss auth inapp
 * @param {string} inAppModal - DOM element of the inApp
 */
function dismissAuthInApp(inAppModal) {
    var dismissAuthUrl = inAppModal.data("auth-dismiss-url");
    var inAppId = inAppModal.attr("id");
    $.ajax({
        url: dismissAuthUrl,
        type: "POST",
        context: this,
        dataType: "JSON",
        data: {
            inAppId: inAppId
        }
    });
}

/**
 * Stores in cookie dismiss value for inapp
 * @param {string} inAppModal - DOM element of the inApp
 */
function dismissCookieInApp(inAppModal) {
    var inAppId = inAppModal.attr("id");
    var inAppCookie = getInAppsCookie();
    var inAppCookieValue = inAppCookie.split("|");
    var recurrenceData = JSON.parse(inAppCookieValue[0]);
    
    recurrenceData[inAppId] = -1;
    updateInAppsCookie(JSON.stringify(recurrenceData), inAppCookieValue[1]);
}

/**
 * Get cookie with the inApps recurrence data
 * @returns {string} cookie value of the inApps recurrence
 */
function getInAppsCookie() {
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(";");
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === " ") {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(cookieInAppName) === 0) {
            return cookieItem.substring(cookieInAppName.length+1, cookieItem.length);
        }
    }
    return ;
}

/**
 * Creates a cookie value to store the inApp recurrence data
 * @param {string} value - value to be in the cookie
 */
function setInAppsCookie(value) {
    let date = new Date();
    date.setTime(date.getTime() + (cookieExpDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cookieInAppName + "=" + value + "|" + date.toUTCString() + "; " + expires + "; path=/";
}

/**
 * Updates the cookie value of the inApp recurrence data
 * @param {string} value - value to be in the cookie
 */
function updateInAppsCookie(value, expireDate) {
    const expires = "expires=" + expireDate;
    document.cookie = cookieInAppName + "=" + value + "|" + expireDate + "; " + expires + "; path=/";
}

export { showInApp, handleDismissInApp };
